import { render } from "./iconMailSend.vue?vue&type=template&id=564490bd"
import script from "./iconMailSend.vue?vue&type=script&lang=js"
export * from "./iconMailSend.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__